/*
  Selettore lingua IT / EN + traduzione lato client (Google Translate mascherato).
  Soluzione temporanea, in attesa della lingua inglese nativa su /en/.

  PERCHE' STA IN UN FILE ASSET E NON INLINE NELL'HEADER
  Il blocco cookie di Iubenda e' configurato con `cmp_block_inline: true`: analizza
  gli script scritti dentro la pagina e neutralizza (type="text/plain") quelli che
  scrivono cookie, a prescindere dal servizio. Con la logica inline il selettore
  restava morto anche DOPO l'accettazione del banner, perche' il vendor risulta
  "unknownVendor" e non viene mai sbloccato. Verificato il 07/10/2026 pilotando un
  browser vero: stesso trattamento tocca a `modal-newsletter.liquid`, quindi e' un
  comportamento preesistente del sito, non introdotto da qui.
  Da file esterno lo scanner degli inline non interviene.

  NOTA DI SOSTANZA: il cookie `googtrans` e' di prima parte e serve solo a ricordare
  la lingua scelta dal visitatore. Lo script di Google, invece, e' un terzo a cui
  viene inviato il contenuto della pagina: se si vuole essere rigorosi va dichiarato
  nella configurazione Iubenda e caricato solo dopo il consenso.
*/
(function () {
  var COOKIE = /(?:^|;\s*)googtrans=\/it\/([a-zA-Z-]+)/;

  function currentLang() {
    var m = document.cookie.match(COOKIE);
    return (m && m[1]) ? m[1] : 'it';
  }

  /* Lo stato attivo si decide qui e non in Liquid: Shopify serve le pagine dalla
     CDN e sono condivise fra visitatori, mentre la lingua sta nel cookie del
     singolo. Una pagina in cache mostrerebbe la lingua di qualcun altro. */
  function markActive() {
    var cur = currentLang();
    var opts = document.querySelectorAll('[data-pv2-lang-set]');
    for (var i = 0; i < opts.length; i++) {
      var on = opts[i].getAttribute('data-pv2-lang-set') === cur;
      opts[i].classList.toggle('is-active', on);
      opts[i].setAttribute('aria-current', on ? 'true' : 'false');
    }
  }

  function setLang(lang) {
    if (lang === currentLang()) return;
    var dead = 'Thu, 01 Jan 1970 00:00:00 UTC';
    /* Cancellato in entrambe le forme, con e senza dominio: Google ne scrive una
       sola ma quale dipende da come e' stata impostata, e lasciarne viva una
       rimanderebbe alla lingua precedente. */
    document.cookie = 'googtrans=; expires=' + dead + '; path=/';
    document.cookie = 'googtrans=; expires=' + dead + '; path=/; domain=.' + location.hostname;
    if (lang !== 'it') {
      var v = 'googtrans=/it/' + lang;
      document.cookie = v + '; path=/';
      document.cookie = v + '; path=/; domain=.' + location.hostname;
    }
    window.location.reload();
  }

  /* ===== ATTIVAZIONE DELLA TRADUZIONE =====
     Google non traduce in modo affidabile leggendo il solo cookie: va pilotato il
     <select> che il widget inietta, simulando il "change" che si aspetta.
     Tre accorgimenti, aggiunti dopo le segnalazioni del 07/10/2026 ("a volte da
     mobile non traduce, devo ricaricare"):
     1. non si dipende dalla sola callback di Google: il tentativo parte anche
        subito dopo aver aggiunto lo script, cosi' se la callback non arriva il
        meccanismo non resta fermo;
     2. l'attesa del <select> e' lunga (20s): su rete mobile il widget ci mette;
     3. soprattutto, si VERIFICA l'esito. Quando traduce, Google mette la classe
        `translated-ltr` sull'elemento <html>: se dopo il "change" quella classe
        non compare, si riprova invece di dare per riuscita un'operazione fallita.
        Era questo il caso che costringeva a ricaricare a mano. */

  function isTranslated() {
    var c = document.documentElement.className || '';
    return c.indexOf('translated-ltr') > -1 || c.indexOf('translated-rtl') > -1;
  }

  function fireSelect(lang) {
    var sel = document.querySelector('select.goog-te-combo');
    if (!sel) return false;
    sel.value = lang;
    sel.dispatchEvent(new Event('change'));
    return true;
  }

  var attempts = 0;

  function forceTranslate(lang, tries) {
    if (!lang || lang === 'it') return;
    if (isTranslated()) return;
    tries = tries || 0;

    if (!fireSelect(lang)) {
      /* il widget non c'e' ancora: ~20 secondi di attesa, poi si lascia perdere */
      if (tries > 80) return;
      setTimeout(function () { forceTranslate(lang, tries + 1); }, 250);
      return;
    }

    /* select pilotato: ora si controlla che abbia davvero tradotto */
    attempts++;
    setTimeout(function () {
      if (isTranslated() || attempts > 4) return;
      forceTranslate(lang, 0);
    }, 2500);
  }

  function wire() {
    var opts = document.querySelectorAll('[data-pv2-lang-set]');
    for (var i = 0; i < opts.length; i++) {
      opts[i].addEventListener('click', function (e) {
        e.preventDefault();
        setLang(this.getAttribute('data-pv2-lang-set'));
      });
    }
    markActive();
  }

  /* Lo script di Google si scarica SOLO per chi ha scelto una lingua diversa
     dall'italiano. Gli altri, cioe' quasi tutti, non pagano nulla: il selettore e'
     markup e non ha bisogno di quello script per esistere. */
  /* Apre in anticipo le connessioni verso Google: DNS, TCP e TLS costano
     parecchie centinaia di millisecondi su rete mobile, e farli partire mentre
     la pagina si sta ancora leggendo toglie quel tempo dall'attesa. */
  function preconnect() {
    ['https://translate.google.com', 'https://translate.googleapis.com', 'https://www.gstatic.com']
      .forEach(function (href) {
        var l = document.createElement('link');
        l.rel = 'preconnect';
        l.href = href;
        l.crossOrigin = '';
        document.head.appendChild(l);
      });
  }

  function loadGoogle(force) {
    var lang = currentLang();
    if (lang === 'it') return;
    var vecchio = document.querySelector('script[data-pv2-gt]');
    if (vecchio && !force) return;
    /* `force` serve quando lo script risulta aggiunto ma il widget non e' mai
       comparso: su rete mobile capita che il file non arrivi: in quel caso
       riprovare con lo stesso tag non servirebbe, va rimosso e rimesso. */
    if (vecchio && vecchio.parentNode) vecchio.parentNode.removeChild(vecchio);
    preconnect();
    /* Il contenitore puo' non essere ancora stato letto dal browser: questa
       funzione parte durante l'analisi della pagina, non dopo. Se manca lo si
       crea, altrimenti il widget di Google fallirebbe in silenzio. */
    if (!document.getElementById('google_translate_element')) {
      var d = document.createElement('div');
      d.id = 'google_translate_element';
      d.setAttribute('aria-hidden', 'true');
      d.style.display = 'none';
      (document.body || document.documentElement).appendChild(d);
    }
    window.googleTranslateElementInit = function () {
      try {
        new google.translate.TranslateElement({
          pageLanguage: 'it',
          includedLanguages: 'it,en',
          autoDisplay: false
        }, 'google_translate_element');
      } catch (err) {}
      forceTranslate(lang);
    };
    var sc = document.createElement('script');
    sc.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    sc.async = true;
    sc.setAttribute('data-pv2-gt', '1');
    document.head.appendChild(sc);
    /* Secondo binario, indipendente dalla callback: se quella non arriva (script
       lento, bloccato, callback persa) la traduzione parte comunque appena il
       <select> compare. Le due strade sono innocue se si incrociano, perche'
       forceTranslate esce subito se la pagina risulta gia' tradotta. */
    forceTranslate(lang);
  }

  /* Due tempi diversi di proposito:
     - loadGoogle() parte SUBITO, perche' gli serve solo document.head: ogni
       istante guadagnato qui e' un istante in meno di pagina in italiano;
     - wire() aspetta il DOM, perche' deve trovare i bottoni del selettore.
     Prima partivano insieme a DOM pronto, e lo scaricamento di Google cominciava
     molto piu' tardi del necessario. */
  /* ===== PRESIDIO =====
     Caso riprodotto il 07/10/2026 su navigazione indietro, che e' quello che
     capitava su Safari da iPhone ("ogni tanto si perde la traduzione, devo
     ricaricare"). Misurato con una spia su ogni documento:
       pageshow arriva con persisted:true  -> ripristino dalla cache avanti/indietro
       il tag <script> di Google RISULTA PRESENTE (ripristinato col resto del DOM)
       ma select.goog-te-combo NON c'e' piu'  -> il widget non esiste piu'
       e la pagina e' tornata in italiano
     Quindi non basta richiamare il caricamento: vedendo il tag gia' li' usciva
     subito senza fare nulla, e poi si restava ad aspettare un widget che non
     sarebbe mai ricomparso. Va rimosso e rimesso da capo, svuotando anche il
     contenitore, perche' Google si reinizializzi davvero. */

  var presidi = 0;
  var avvio = Date.now();
  var guardia = null;

  function startGuard() {
    if (guardia) clearInterval(guardia);
    avvio = Date.now();
    guardia = setInterval(function () {
      if (currentLang() === 'it' || isTranslated() || Date.now() - avvio > 30000) {
        clearInterval(guardia);
        guardia = null;
        return;
      }
      /* se dopo 8 secondi il widget non e' comparso, quasi sempre vuol dire che
         il file non e' arrivato: si riparte da capo invece di insistere */
      ensure(!document.querySelector('select.goog-te-combo') && Date.now() - avvio > 8000);
    }, 3000);
  }

  function ensure(daCapo) {
    var lang = currentLang();
    if (lang === 'it' || isTranslated()) return;
    if (presidi > 6) return;            /* tetto, per non insistere all'infinito */
    presidi++;
    if (daCapo) {
      var vecchio = document.querySelector('script[data-pv2-gt]');
      if (vecchio && vecchio.parentNode) vecchio.parentNode.removeChild(vecchio);
      var box = document.getElementById('google_translate_element');
      if (box) box.innerHTML = '';
    }
    attempts = 0;
    loadGoogle(daCapo === true);
    forceTranslate(lang);
  }

  var ricaricaFatta = false;

  window.addEventListener('pageshow', function (e) {
    if (!e || !e.persisted) return;
    ricaricaFatta = false;
    var lang = currentLang();
    if (lang === 'it' || isTranslated()) return;

    /* Primo tentativo: ricostruire il widget senza ricaricare. Riesce in circa
       due casi su cinque — dopo un ripristino Google non si lascia pilotare in
       modo affidabile, nemmeno forzando il passaggio da una lingua all'altra. */
    presidi = 0;
    ensure(true);
    startGuard();

    /* Rete finale: se entro 1,8s non ha tradotto si ricarica, cioe' si fa da
       soli quello che l'utente faceva a mano. La ricarica arriva dalla cache del
       browser, quindi e' rapida, e il ripristino dello scorrimento lo gestisce
       gia' il browser.
       Il contatore in sessionStorage impedisce catene di ricariche: dopo una
       ricarica pageshow arriva con persisted:false, quindi questo ramo non si
       ripete, ma la guardia resta per sicurezza. */
    /* Due controlli e non uno. Il primo a 1,8s prende quasi tutti i casi; il
       secondo a 5s serve a quello sfuggente in cui a 1,8s la pagina SEMBRA
       tradotta e poi torna indietro da sola. Se il primo controllo ricarica, il
       documento viene sostituito e il secondo muore con lui, quindi non si
       pestano i piedi. */
    function verificaERicarica() {
      if (ricaricaFatta) return;
      /* Non ci si fida della sola classe `translated-ltr`: dopo un ripristino
         Google puo' lasciarla addosso a una pagina tornata in italiano. Si
         guarda anche se il testo e' davvero cambiato, cercando i tag <font>
         con cui Google avvolge ogni frase tradotta. */
      if (currentLang() === 'it') return;
      if (isTranslated() && document.querySelector('font[dir]')) return;
      var ora = Date.now();
      var ultima = 0;
      try { ultima = parseInt(sessionStorage.getItem('pv2-tr-reload') || '0', 10); } catch (err) {}
      if (ora - ultima < 4000) return;      /* niente catene di ricariche */
      ricaricaFatta = true;
      try { sessionStorage.setItem('pv2-tr-reload', String(ora)); } catch (err) {}
      window.location.reload();
    }

    setTimeout(verificaERicarica, 1800);
    setTimeout(verificaERicarica, 5000);
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    /* tornando in primo piano: se manca il widget si riparte da capo, altrimenti
       basta risollecitare. Safari ferma i timer delle schede in secondo piano,
       quindi i tentativi avviati prima possono essersi spenti per strada. */
    ensure(!document.querySelector('select.goog-te-combo'));
  });

  loadGoogle();
  startGuard();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
})();
